<!-- モーダルフッターが入ります -->
<div class="p-modal-foot01">
  <!-- [15] 申込ボタン -->
  <!-- (4.5) 申込ボタンの状態を以下の通りに切り替える。 -->
  <button
    [disabled]="screenInformationChangeFlag !== true"
    class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
    id="btn-event-apply-id"
  >
    <span (click)="onClickApply()" class="c-btn-primary__text" [innerHTML]="'label.apply.button' | staticMsg"></span>
  </button>
</div>
<!-- //モーダルフッターが入ります -->
